import React from 'react';
import styles from './TeaserMessage.module.css';
import { MessageType } from '../../types/message';

interface TeaserMessageProps {
  message: MessageType;
  onDismiss: () => void;
}

const TeaserMessage: React.FC<TeaserMessageProps> = ({ message, onDismiss }) => {
  return (
    <div className={styles.teaserWrapper} onClick={onDismiss}>
      <div className={styles.content}>
        <div className={styles.header}>
          <img 
            src={message.icon} 
            alt={message.display_name} 
            className={styles.avatar}
          />
          <div className={styles.displayName}>{message.display_name}</div>
        </div>
        {message.content}
        <div className={styles.progressBar}>
          <div className={styles.progressBarFill} />
        </div>
      </div>
    </div>
  );
};

export default TeaserMessage; 